module.exports = __webpack_public_path__ + "static/media/website-link.edb98c82.svg";